import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export default class GetCashDocumentListItem {
  @Expose()
  @IsString()
  contractor!: string; // " Claymore Consulting Group "
  @Expose()
  @IsString()
  currency!: string; // "PLN"
  @Expose()
  @IsString()
  issueDate!: string; // "2022-02-22T00:00:00"
  @Expose()
  @IsOptional()
  @IsString()
  description!: string; // "asdasd";
  @Expose()
  @IsString()
  documentItems!: string; // "test";
  @Expose()
  @IsString()
  documentNumber!: string; // "KP/1/02/2022/RZE";
  @Expose()
  @IsOptional()
  @IsNumber()
  expense!: null | number;
  @Expose()
  @IsOptional()
  @IsNumber()
  expenseInCurrency!: null | number;
  @Expose()
  @IsBoolean()
  hasFile!: boolean; // true;
  @Expose()
  @IsNumber()
  id!: number; // 16506;
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsOptional()
  @IsNumber()
  income!: null | number; // 23;
  @Expose()
  @IsOptional()
  @IsNumber()
  incomeInCurrency!: null | number; // 23;
  @Expose()
  @IsBoolean()
  isCanceled!: boolean; // false;
  @Expose()
  @IsBoolean()
  isEditingLocked!: boolean;
}

export class GetCashDocumentListResponse extends GenericTableResponse<GetCashDocumentListItem> {
  @Type(() => GetCashDocumentListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetCashDocumentListItem>;
}
